import { render, staticRenderFns } from "./BubbleMapsPage.vue?vue&type=template&id=8015d1da"
import script from "./BubbleMapsPage.vue?vue&type=script&lang=js"
export * from "./BubbleMapsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports